import Vue from 'vue'
import VueRouter from 'vue-router'
const Home = () => import('@/views/Home')
const About = () => import('@/views/About')
const MentionsLegales = () => import('@/views/MentionsLegales')
const notFound = () => import('../views/notFound')

const CovidEmployeurs = () => import('@/views/covid/CovidEmployeurs')
const CovidSalaries = () => import('@/views/covid/CovidSalaries')
const CovidBranchesPro = () => import('@/views/covid/CovidBranchesPro')

const OtherEmployeurs = () => import('@/views/other/OtherEmployeurs')
const OtherSalaries = () => import('@/views/other/OtherSalaries')

//const OtherBranchesPro = () => import('@/views/other/OtherBranchesPro')

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/qui-sommes-nous',
    name: 'About',
    component: About
  },
  {
    path: '/mentions-legales',
    name: 'MentionsLegales',
    component: MentionsLegales
  },
  {
    path: '/covid/employeurs',
    name: 'CovidEmployeurs',
    component: CovidEmployeurs
  },
  {
    path: '/covid/salaries',
    name: 'CovidSalaries',
    component: CovidSalaries
  },
  {
    path: '/covid/branches-professionnelles',
    name: 'CovidBranchesPro',
    component: CovidBranchesPro
  },


  {
    path: '/autre/employeurs',
    name: 'OtherEmployeurs',
    component: OtherEmployeurs
  },
  {
    path: '/autre/salaries',
    name: 'OtherSalaries',
    component: OtherSalaries
  },


  /*{
    path: '/branches-professionnelles',
    name: 'OtherBranchesPro',
    component: OtherBranchesPro
  },*/

  // ------------ ALL ----------------
  {
    path: '/404',
    name: 'notFound',
    component: notFound,
  },

  {
    path: '*',
    redirect: '/404',
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

export default router
